module.exports = __webpack_public_path__ + "static/media/S-task16_adjMatrix.7362fb6e.png";